/** List of supported whitelabel brand identifiers. */
export const whitelabelsList = ['tauroMarkets', 'tauroMarketsMauritius'] as const
